var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoader)?_c('div',{staticClass:"intro-loader"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-loader-block"},[_c('img',{staticClass:"intro-loader__logo",attrs:{"src":"/app/themes/tanglin/dist/images/logo-full.svg","alt":""}})])
}]

export { render, staticRenderFns }